module.exports = __webpack_public_path__ + "img/sGoldenWar_350x350.d691b0fe.jpg";